/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_QuantityInputs */

const vi_weighing_quantity = /** @type {(inputs: Weighing_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng (kg)`)
};

/**

* @param {Weighing_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_quantity = /** @type {((inputs?: Weighing_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_quantity(inputs)
});